export default __webpack_public_path__ + "static/media/FrameBackground.558e0a27.webp";